import { render, staticRenderFns } from "./policyWft.vue?vue&type=template&id=a0b9e6c4"
import script from "./policyWft.vue?vue&type=script&lang=js"
export * from "./policyWft.vue?vue&type=script&lang=js"
import style0 from "./policyWft.vue?vue&type=style&index=0&id=a0b9e6c4&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports